import gql from 'graphql-tag';

export const NAME = 'compositions_TechAdmin_dealerTopNav';

export const dealerTopNavQuery = gql`
  query ${NAME} (
    $id: ID!,
  ) {
    dealer (
      id: $id,
    ) {
      id
      name
    }
  }
`;

export default dealerTopNavQuery;



// WEBPACK FOOTER //
// ./src/compositions/TechAdmin/DealerDetails/TopBar/dealerTopNavQuery.js